import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setCoursesOverviewRedux } from 'store/CoursesOverview/actions'
import { setCoursesOverviewFetched } from 'store/Dashboard/actions'
import { setCoursesOverview } from 'store/Dashboard/actions'
import AxiosInstance from 'utils/AxiosInstance'

export function useCoursesOverviews() {
  const dispatch = useDispatch()

  const { coursesOverviewsFetched } = useSelector((state) => state.dashboard)

  const fetchCourseOverview = () => {
    dispatch(setCoursesOverview({ loadingCoursesOverview: true }))
    AxiosInstance.get('/users/self/course-overview').then((response) => {
      dispatch(setCoursesOverview({ coursesOverview: response }))
      dispatch(setCoursesOverview({ loadingCoursesOverview: false }))
      dispatch(setCoursesOverviewFetched(true))
    })
  }

  useEffect(() => {
    if (coursesOverviewsFetched) return
    fetchCourseOverview()
  }, [coursesOverviewsFetched])

  return null
}
